export default __webpack_public_path__ + "static/media/User.25b12661.svg";